export const dailyViewRoutes = [
  {
    name: 'home',
    path: '/home',
    component: () => import('@/modules/daily-view/views/DailyViewFeatureFlag.vue')
  }
]
